import React from 'react';
import Link from 'components/Link/Link';
import s from './CalculatorCard.scss';
import { getStringToLowerCase } from '../../../../../utils/common';

const CalculatorCard = ({
  name,
  desc,
  url,
  gaCategory,
  imageId = 76150242,
  isArticleshowPage = false,
  ga4Type,
  ga4Category,
}) => (
  <Link
    className={s.calculatorLink}
    forceTargetBlank
    to={url}
    data={{
      gaAction: isArticleshowPage ? 'click' : 'click-other-calculators',
      gaLabel: isArticleshowPage ? 'financial-calculator_click' : name,
      gaCategory,
    }}
    ga4Data={
      ga4Type && [
        {
          event: 'user_click',
          type: `${ga4Type}`,
          category: name ? getStringToLowerCase(name) : ga4Category,
        },
      ]
    }
  >
    <div className={s.calculator_card}>
      <div className={s.left_area}>
        <h4 className={s.title}>{name}</h4>
        <div className={s.desc}>
          <p>{desc}</p>
        </div>
        <span className={s.calculate_button}>Calculate Now</span>
      </div>
      <div className={s.right_area}>
        <div className={s.img_wrap}>
          <img
            src={`https://static.toiimg.com/photo/${imageId}.cms`}
            alt={name}
          />
        </div>
      </div>
    </div>
  </Link>
);

export default CalculatorCard;
